import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import {
  HIGH_VIS_FILTER,
  highVisSlateComponent,
} from "@faire/web--source/slate/utils/highVisSlateComponent";
import styled from "styled-components";

const CenteredColumn = styled(Column).attrs({
  align: "center",
  justify: "center",
});

interface IDropzoneContainerProps {
  height?: number;
  width?: number;
  error?: boolean;
}

export const DropzoneContainer = CenteredColumn<IDropzoneContainerProps>`
  cursor: pointer;
  position: relative;
  outline-offset: -8px;
  outline: 1px dashed;
  outline-color: ${(props) =>
    props.error ? Core.border.critical : Core.text.subdued};
  width: ${(props) =>
    props.width !== undefined ? `${props.width}px` : "100%"};
  height: ${(props) =>
    props.height !== undefined ? `${props.height}px` : "200px"};
  max-width: 100%;
  background-color: ${Core.surface.subdued};
  ${highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT)}
`;

export const MaxSizeDiv = styled.div`
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  width: 100%;
`;

interface ICentralContentWrapperProps {
  color: string;
}

export const CentralContentWrapper = CenteredColumn<ICentralContentWrapperProps>`
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${(props) => props.color};
`;
